import React from "react";
import { useSelector } from "react-redux";

// components
import {
  TodaysSales,
  TodaysReservations,
  ReceivableCard,
  SmallCards,
  TodaysVouchers,
  AdBanner,
} from "components/home";

const HomeContents = () => {
  const {
    todaysReservations,
    todaysSales,
    todaysVouchers,
    receivableSum,
    appLinkCount,
    qnaCount,
  } = useSelector((state) => state.home);
  const { branchUseYn, seqPartnerBranch } = useSelector(
    (state) => state.partner
  );
  const isAll = branchUseYn === "Y" && seqPartnerBranch === 0;

  return (
    <>
      <TodaysReservations reservationData={todaysReservations} />

      <AdBanner />

      <TodaysSales saleData={todaysSales} />

      <TodaysVouchers voucherData={todaysVouchers} isAll={isAll} />

      <ReceivableCard amount={receivableSum} isAll={isAll} />

      <SmallCards appLinkCount={appLinkCount} qnaCount={qnaCount} />
    </>
  );
};

export default HomeContents;
